import React from "react";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import Utils from "../../configs/Utils";

const PageFooter = ({ compact = false }) => {
  const year = new Date().getFullYear();
  const appTitle = process.env.REACT_APP_TITLE || "Thadotech Gateway Manager";

  const quickLinks = [
    { to: "/", label: "Overview" },
    { to: "/orders", label: "Orders" },
    { to: "/stores", label: "Stores" },
    { to: "/workspace", label: "Workspace" },
  ];

  const supportLinks = [
    { to: "/settings", label: "Settings" },
    { to: "/mail-templates", label: "Email templates" },
    { to: "/policy", label: "Policy" },
  ];

  const legalLinks = [
    { to: "/policy", label: "Policy" },
    { to: "/profile", label: "Account" },
  ];

  return (
    <footer className={`main-footer ${compact ? "compact-footer" : ""}`.trim()}>
      {!compact && (
        <div className="footer-main-content container">
          <div className="footer-branding">
            <Link to="/" className="footer-brand-mark" aria-label={appTitle}>
              <Image
                src={Utils.getPublicImage("/assets/images/logo-main.png")}
                className="footer-brand-logo"
                alt={appTitle}
              />
            </Link>
            <p className="footer-eyebrow">Unified commerce operations</p>
            <h6 className="footer-title mb-2">{appTitle}</h6>
            <p className="footer-description mb-0">
              A focused command surface for stores, orders, workspaces, and
              synchronized gateway activity across your sales channels.
            </p>
          </div>

          <div className="footer-links-wrap">
            <div>
              <h6 className="footer-section-title">Quick Links</h6>
              <ul className="footer-links-list">
                {quickLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h6 className="footer-section-title">Support</h6>
              <ul className="footer-links-list">
                {supportLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
                <li>
                  <a href="mailto:support@onealdern.com">support@onealdern.com</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-status-card" aria-label="System status">
            <span className="status-dot" aria-hidden="true" />
            <div>
              <p className="status-title mb-1">System operating normally</p>
              <small className="status-text">
                API sessions, store syncs, and background jobs are online.
              </small>
            </div>
          </div>
        </div>
      )}

      <div className="footer-bottom container">
        <p className="copy-right mb-0">
          &copy; {year} <strong>{appTitle}</strong>. All rights reserved.
        </p>
        <div className="footer-legal-links">
          {legalLinks.map((link) => (
            <Link key={link.to} to={link.to}>
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default PageFooter;
